import React from 'react'
import Quickpay from './Quickpay'

const Qpay = () => {
  return (
    <>
    <Quickpay/>
    </>
  )
}

export default Qpay